<template>
    <UtilitiesWebView url="/events-programs" />
</template>
